import type { ReactNode } from 'react';

import classNames from 'classnames';

import styles from './styles.module.less';

export interface CheckboxSegmentedOption {
  value: string | number;
  label: ReactNode;
}

export interface CheckboxSegmentedProps {
  onChange?: (value: Array<string | number>) => void;
  value?: Array<string | number>;
  options?: CheckboxSegmentedOption[];
  disabled?: boolean;
  fluid?: boolean;
  className?: string;
}

export const CheckboxSegmented = ({
  onChange = () => {},
  value = [],
  options = [],
  disabled = false,
  fluid = false,
  className,
}: CheckboxSegmentedProps) => {
  const toggleDay = (day: string | number) => {
    if (disabled) return;
    const newSelectedDays = value.includes(day) ? value.filter(d => d !== day) : [...value, day];
    onChange(newSelectedDays);
  };

  return (
    <div
      className={classNames(
        styles.checkBoxSegmentedContainer,
        fluid && styles.checkBoxSegmentedContainerFluid,
        className,
      )}
    >
      {options.map(({ label, value: day }) => (
        <button
          type="button"
          key={day}
          className={classNames(
            styles.checkBoxSegmented,
            value.includes(day)
              ? styles.checkBoxSegmentedSelected
              : styles.checkBoxSegmentedUnselected,
          )}
          onClick={() => toggleDay(day)}
          disabled={disabled}
        >
          <span>{label}</span>
        </button>
      ))}
    </div>
  );
};
